export class NodeAdapter {
  static toInputDTO(req: any[]): any {
    const getOptionValue = (arr: any[], key: string): boolean => {
      if (!Array.isArray(arr)) return false;
      const option = arr.find((item) => item.key === key);
      return !!(option && option.value === true);
    };

    const getDecimalDigit = (decimal: any[]): number =>
      Array.isArray(decimal) && decimal.find((item) => item.value === true)
        ? Number(decimal.find((item) => item.value === true).key)
        : 0;

    const data_properties_list = req.map((e: any) => {
      const hasValidUnit = e.unit != null && e.unit !== "";
      return {
        value: e.id,
        name: e.name,
        unit_exists: hasValidUnit,
        unit: hasValidUnit ? e.unit : "",
        decimal_digit: getDecimalDigit(e.decimal),
        is_binary: getOptionValue(e.imput_type, "imput_type.zero"),
      };
    });

    return { data_properties_list };
  }

  static toOutputDTO(res: any, language: string = "ja"): any[] {
    return res.data_properties_list.map((e: any) => {
      const name = language === "en" && e.name_en ? e.name_en : e.name;
      return {
        id: e.value,
        name: name,
        unit: e.unit ?? null,
        regexp: null,
        decimal: [0, 1, 2, 3, 4].map((attr) => ({
          id: attr.toString(),
          key: attr.toString(),
          value: e.decimal_digit === attr,
        })),
        imput_type: ["imput_type.liner", "imput_type.zero"].map((attr) => ({
          id: attr.toString(),
          key: attr.toString(),
          value: e.is_binary
            ? attr === "imput_type.zero"
            : attr === "imput_type.liner",
        })),
        updated_at: e.data_properties_fixed_at ?? null,
      };
    });
  }
}
